// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1KsFV","actions":"GroupTable_actions__E77gy","deleteModalFooter":"GroupTable_deleteModalFooter__1v84f"};